export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "plugins-publish": { "defaultSubmitButtonText": "Send" } } } });
};